import React, { FC, PropsWithChildren } from 'react'
import { useBreakpoint } from './useBreakpoint'

export const Breakpoint: FC<PropsWithChildren<{ display: number | number[] }>> = ({
  display,
  children,
}) => {
  const breakpoint = useBreakpoint()

  if (Array.isArray(display) && display.includes(breakpoint)) {
    return <>{children}</>
  }

  if (breakpoint === display) {
    return <>{children}</>
  }

  return null
}
